import { useState } from "react";
import type { LotsFilterFormState } from "../lots.types";
import {
  MeasuredWeightFilter,
  ProjectedWeightFilter,
  RETREAT_FILTER_ALL_VALUE,
} from "../utils/lots.utils";

const initialState: LotsFilterFormState = {
  measuredWeight: MeasuredWeightFilter.All,
  projectedWeight: ProjectedWeightFilter.All,
  retreatId: RETREAT_FILTER_ALL_VALUE,
  searchText: "",
};

export function useFilterForm() {
  const [filterForm, setFilterForm] = useState<LotsFilterFormState>({
    ...initialState,
  });

  const handleChangeFilter = <T extends keyof LotsFilterFormState>(
    field: T,
    value: LotsFilterFormState[T]
  ) => {
    setFilterForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleResetFilter = () => {
    setFilterForm({ ...initialState });
  };

  const isFilterApplied = Object.entries(filterForm).some(
    ([key, value]) => initialState[key as keyof LotsFilterFormState] !== value
  );

  return {
    filterForm,
    handleChangeFilter,
    handleResetFilter,
    isFilterApplied,
  };
}
